module.exports = __webpack_public_path__ + "media/images/pages/sample_images/sample-portrait-4e71496b407e911d5abe5f0d3aecfe82.jpeg";